import { render } from "./SearchPopover.vue?vue&type=template&id=25461212"
import script from "./SearchPopover.vue?vue&type=script&lang=js"
export * from "./SearchPopover.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__